import { render, staticRenderFns } from "./main-section.vue?vue&type=template&id=4c2a15b0&scoped=true&"
import script from "./main-section.vue?vue&type=script&lang=js&"
export * from "./main-section.vue?vue&type=script&lang=js&"
import style0 from "./main-section.vue?vue&type=style&index=0&id=4c2a15b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2a15b0",
  null
  
)

export default component.exports